var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleCheckRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2294_6665)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.40039,
    cy: 8,
    r: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40039 0C3.98164 0 0.400391 3.58125 0.400391 8C0.400391 12.4187 3.98164 16 8.40039 16C12.8191 16 16.4004 12.4187 16.4004 8C16.4004 3.58125 12.8191 0 8.40039 0ZM12.0191 6.61875L8.01914 10.6187C7.84727 10.7906 7.62539 10.875 7.40039 10.875C7.17539 10.875 6.95227 10.79 6.78133 10.6191L4.78133 8.61913C4.44039 8.27725 4.44039 7.72256 4.78133 7.38069C5.1232 7.03881 5.67789 7.03881 6.01977 7.38069L7.40039 8.7625L10.7816 5.38125C11.1235 5.03937 11.6782 5.03937 12.0201 5.38125C12.3598 5.72187 12.3598 6.27813 12.0191 6.61875Z",
    fill: "#3FAE7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2294_6665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.400391)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckRounded);
export default __webpack_public_path__ + "static/media/circle_check_rounded.3273d58760a4d67a546581de5e31dbc2.svg";
export { ForwardRef as ReactComponent };